import { buildScopedApiParams } from "./workspace/workspaceScope";
export { ensureArray } from "./utils/arrayUtils";

export const API_KEY = process.env.REACT_APP_SIGNALFLY_API_KEY;
export const BASE_URL =
  process.env.REACT_APP_BASE_URL ||
  "https://signalflyglobal.com";

export const AUTH_BASE_URL =
  process.env.REACT_APP_AUTH_BASE_URL ||
  "https://signalflyglobal.com";

export function getApiHeaders(extraHeaders = {}) {
  return {
    "X-SIGNALFLY-KEY": API_KEY,
    ...extraHeaders,
  };
}

export function buildApiUrl(path, params = {}) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null && item !== '') {
          searchParams.append(key, item);
        }
      });
      return;
    }

    searchParams.set(key, value);
  });

  const query = searchParams.toString();
  return `${BASE_URL}${path}${query ? `?${query}` : ''}`;
}

export function buildScopedApiUrl(path, workspace, params = {}) {
  const query = buildScopedApiParams(workspace, params).toString();
  return `${BASE_URL}${path}${query ? `?${query}` : ''}`;
}

// The CRA development server proxies relative V2 calls to the production ALB.
// This keeps local npm-start traffic same-origin in the browser while deployed
// builds continue to call the configured ALB origin directly.
export function buildMtfV2ApiUrl(path, workspace, params = {}) {
  const scopedUrl = buildScopedApiUrl(path, workspace, params);
  return process.env.NODE_ENV === "development"
    ? scopedUrl.slice(BASE_URL.length)
    : scopedUrl;
}
